import BaseService from "../../../services/BaseService.ts";
import {API} from '@aws-amplify/api';

const v2ApiName = 'TenantManagementServiceV2API';
const collectionPath = '/users';

/**
 * Look up a user by email address using the secured V2 endpoint.
 * GET /v2/users/lookup?email_address=x
 *
 * The V2 endpoint returns a 302 redirect to /users/{user-id}.
 * Amplify's API module with `response: true` captures the redirect
 * response including the location, matching the V1 behavior.
 */
export const lookupUserByEmail = (emailAddress: string) => {
    const path = '/users/lookup';
    const options = {
        queryStringParameters: { email_address: emailAddress },
        response: true,
        headers: { 'Authorization': '' },
    };
    const baseService = new BaseService(v2ApiName, path);
    return baseService.makeGetApiCall(v2ApiName, path, options);
};

/**
 * Fetch a single user by ID (location path from lookup redirect).
 * Uses V2 API with API key only (no auth — pre-login flow).
 */
export const fetchUserWithLocation = async (location: string) => {
    console.log(`making GET call (V2) to ${v2ApiName} with path: ${location}`);
    try {
        return await API.get(v2ApiName, location, {
            headers: { 'Authorization': '' },
        });
    } catch (e: unknown) {
        console.trace('fetchUserWithLocation error:', e);
        if (typeof e === 'string') {
            throw new Error(e);
        } else if (e instanceof Error) {
            throw new Error(e.message);
        }
        throw e;
    }
};

/**
 * Fetch a single user's profile by ID.
 * Used by useAuth.ts during session initialization to check tc.accepted.
 * Authenticated call — Amplify's custom_header attaches the ID token.
 */
export const fetch = (id: string) => {
    const baseService = new BaseService(v2ApiName, collectionPath);
    return baseService.fetch(id);
};
